export default {
  strict: true,
  namespaced: true,
  state: {
    show: false,
    showMenuButton: true
  },
  mutations: {
    hide (state) {
      state.show = false
    },
    show (state) {
      state.show = true
    },
    hideMenuButton (state) {
      state.showMenuButton = false
    },
    showMenuButton (state) {
      state.showMenuButton = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/side-menu.js